import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CreateProductGroupRequest, OrgUnitResponse, UpdateOrgUnitRequest } from '../models/org-unit.models';

@Injectable({
  providedIn: 'root',
})
export class OrganizationService {
  private readonly organizationsUrl = `${environment.baseUrl}organizations`;

  constructor(private readonly http: HttpClient) {}

  createOrganization(body: CreateProductGroupRequest): Observable<OrgUnitResponse> {
    return this.http.post<OrgUnitResponse>(this.organizationsUrl, body);
  }

  getOrganizations(): Observable<OrgUnitResponse[]> {
    return this.http.get<OrgUnitResponse[]>(this.organizationsUrl);
  }

  searchOrganizations(name: string): Observable<OrgUnitResponse[]> {
    const params = new HttpParams().set('name', name);
    return this.http.get<OrgUnitResponse[]>(`${this.organizationsUrl}/search`, { params });
  }

  updateOrganization(id: string, body: UpdateOrgUnitRequest): Observable<OrgUnitResponse> {
    return this.http.put<OrgUnitResponse>(`${this.organizationsUrl}/${id}`, body);
  }

  deleteOrganization(id: string): Observable<void> {
    return this.http.delete<void>(`${this.organizationsUrl}/${id}`);
  }
}
